import React from 'react';
import './Footer.css';

const Footer = () => {
    const year = new Date().getFullYear();
    const toolTipText = process.env.REACT_APP_PRIVACY_TOOLTIP
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="help-link">
                    <a href="https://jetnet.aa.com/sites/policy-center/knowledgearticle/286526/privacy-policy-for-american-airlines-team-members"target="_blank"rel="noreferrer">Privacy Policy</a>

                    <span className="tooltip-wrapper">
                        <span className="info-icon" aria-label="Information" tabIndex={0}>
                            Ⓘ
                        </span>
                        <span className="tooltip-box" role="tooltip">
                            { toolTipText }
                        </span>
                    </span>
                </div>

                <div className="company-name">© American Airlines {year}</div>
            </div>
        </footer>
    );
};

export default Footer;